import Head from './../components/Head';
import Footer from './../components/Footer';
import Course from './components/Course';
import ResourceCenter from './components/ResourceCenter.vue';
import SpocCourse from './components/SpocCourse.vue';
import MoocCourse from './components/MoocCourse.vue';
import TeacherList from './components/TeacherList';
import BannerList from './components/BannerList'; // import News from './components/News'

import TeacherData from './components/TeachData.vue';
import Link from '../components/aboutLink.vue';
import TeachingCenterList from './components/TeachingCenterList.vue';
import CourseGroup from './components/CourseGroup/index.vue';
import News from './components/News/index.vue';
import Teacher from './components/Teacher/index.vue';
import Lecture from './components/Lecture/index.vue';
import ResourceBase from './components/ResourceBase.vue';
import TeachingCourses from './components/TeachingCourses.vue';
export default {
  components: {
    Head,
    Course,
    TeacherList,
    BannerList,
    News,
    Footer,
    SpocCourse,
    MoocCourse,
    TeacherData,
    Link,
    ResourceCenter,
    TeachingCenterList,
    CourseGroup,
    Teacher,
    Lecture,
    ResourceBase,
    TeachingCourses
  },

  provide() {
    return {
      uuid: () => this.uuid,
      userId: () => this.userId
    };
  },

  created() {
    this.getDataList(); // this.getLive();
  },

  data() {
    return {
      menuCode: '10301',
      dataList: [],
      liveList: [],
      footerItem: null,
      dataItem: null,
      bannerItem: null,
      moocItem: null,
      spocItem: null,
      newsItem: null,
      resourceItem: null,
      teacherItem: null,
      teachingCenterItem: null,
      teachingCourseItem: null,
      menuInfo: {},
      userInfo: null,
      zhsRole: 0,
      uuid: '',
      userId: '',
      courseGroupItem: null,
      lectureItem: null
    };
  },

  methods: {
    async getDataList() {
      const res = await this.$http.getDataList();
      console.log('首页数据', res);
      this.dataList = res;
      this.footerItem = this.dataList.find(item => item.function_id == '10303');
      this.dataItem = this.dataList.find(item => item.function_id == '10304');
      this.bannerItem = res.find(item => item.function_id == '10302');
      this.moocItem = res.find(item => item.function_id == '10401');
      this.spocItem = res.find(item => item.function_id == '10402');
      this.newsItem = res.find(item => item.function_id == '10701');
      this.teacherItem = res.find(item => item.function_id == '10501');
      this.teachingCenterItem = res.find(item => item.function_id == '51001');
      this.courseGroupItem = res.find(item => item.function_id == '51007');
      this.lectureItem = res.find(item => item.function_id == '40005');
      this.teachingCourseItem = res.find(item => item.function_id == '51006');
      this.resourceItem = res.find(item => item.function_id == '10305');
    },

    // async getLive() {
    //   const res = await this.$http.getHomeLive();
    //   // console.log('首页直播', res)
    //   this.liveList = res;
    // },
    getUserInfo(data) {
      this.userInfo = data;
      this.uuid = data.uuid;
      this.userId = data.id;
    },

    getZhsRole(data) {
      this.zhsRole = data || 0; // console.log(this.zhsRole);
    }

  }
};